module.exports = __webpack_public_path__ + "media/night-banner.f2bb4c7a.mp4";